import React, { useEffect } from "react";
import ArdrendHeader from "../../components/AllVon/VonHeader/ArdrendHeader";
import ArdrendFooter from "../../components/AllVon/VonFooter/ArdrendFooter";
import ArdrendHero from "./Component/ArdrendHero";
import Accreditation from "./Component/Accreditation";
import ArdrendStatistics from "./Component/ArdrendStatistics";
import ArdrendCategories from "./Component/ArdrendCategories";
import ArdrendMainCourses from "./Component/ArdrendMainCourses";
import ArdrendCourses from "./Component/ArdrendCourses";
import ArdrendScholarshipPanel from "./Component/ArdrendScholarshipPanel";
import ArdrendPath from "./Component/ArdrendPath";
import ArdrendTestimonials from "./Component/ArdrendTestimonials";
import ArdrendFAQ from "./Component/ArdrendFAQ";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-full flex flex-col font-sans bg-white text-[#0b0f19]">
      <main className="flex-grow">
        <ArdrendHeader />
        <ArdrendHero />
        <ArdrendStatistics />
        <ArdrendCategories />
        <ArdrendCourses />
        <ArdrendScholarshipPanel />
        <ArdrendMainCourses />
        <ArdrendPath />
        <ArdrendTestimonials />
        <ArdrendFAQ />
        <Accreditation />
      </main>
      <ArdrendFooter />
    </div>
  );
};

export default LandingPage;
